import WebSocketRails from 'src/websocket-rails-node/WebSocketRails'

// singleton: https://www.sitepoint.com/javascript-design-patterns-singleton/
// observer pattern: http://www.dofactory.com/javascript/observer-design-pattern
class Docendo {
  constructor () {
    console.log('open docendo connection')
    Docendo.self = this
  }

  open () {
    console.log('open', this)
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone
    this.state.websocket = process.env.NODE_ENV === 'production' ? new WebSocketRails(window.location.host + '/websocket?tz=' + tz) : new WebSocketRails('localhost:3000/websocket?tz=' + tz)
    this.state.websocket.on_open = this.opened
    this.state.websocket.bind('connection_closed', this.closed)
  }

  opened () {
    console.log('opened', this)
    window.dispatcher = this // expose the websocket as global
    Docendo.self.state.retries = 1
    Docendo.self.notifyConnected()
  }

  closed () {
    console.log('closed', this)
    setTimeout(function () {
      if (Docendo.self.state.retries < 16) Docendo.self.state.retries *= 2
      Docendo.self.open(Docendo.opened, Docendo.closed)
    }, Docendo.self.state.reconnectTimeout * Docendo.self.state.retries)
    Docendo.self.notifyDisconnected('closed', Docendo.self)
  }

  subscribeConnected (fn) {
    this.state.observersConnected.push(fn)
  }

  subscribeDisconnected (fn) {
    this.state.observersDisconnected.push(fn)
  }

  notifyConnected () {
    Docendo.self.state.observersConnected.forEach(function (item) {
      item.call()
    })
  }

  notifyDisconnected () {
    Docendo.self.state.observersDisconnected.forEach(function (item) {
      item.call()
    })
  }

  // to receive push messages from the server bind to a message and suppy a function
  bind (message, func) {
    this.state.websocket.bind(message, func)
  }

  // PUBLIC API FROM HERE

  // get the state of the connection
  state () {
    return this.state.websocket.state
  }

  // get calendar events for calendars the timestamp range
  // dispatcher.trigger('api.events.list', {calendar_ids: [5,138069], start: "2021-02-01 00:00", end: "2021-02-07 00:00"}, function(data) {console.log(data)})
  // dispatcher.trigger('api.events.list', {calendar_ids: [5,138069], start: "2021-02-01 00:00", end: "2021-02-07 00:00", have_collision: false}, function(data) {console.log(data)})
  eventsFromCalendars (calendarIds, start, end, haveCollision, success, failure) {
    this.state.websocket.trigger('api.events.list',
      {
        calendar_ids: calendarIds,
        start: start,
        end: end,
        have_collision: haveCollision
      },
      success, failure)
  }

  // get public calendar events for calendars the timestamp range
  // dispatcher.trigger('api.events.list_public', {calendar_id: 5, start: "2021-02-01 00:00", end: "2021-02-07 00:00"}, function(data) {console.log(data)})
  publicEventsFromCalendar (calendarId, start, end, success, failure) {
    this.state.websocket.trigger('api.events.list_public',
      {
        calendar_id: calendarId,
        start: start,
        end: end
      },
      success, failure)
  }

  // get calendar events for calendars with ids
  // events in range start to end both inclusive
  // date format YYYY-MM-DD
  // dispatcher.trigger('api.events.list', {calendar_ids: [7], start: "2022-02-28 00:00", end: "2022-03-04 00:00"}, function(data) {console.log(data)})
  calendarEvents2 (calendarIds, start, end, eventTypeFilter, success, failure) {
    this.state.websocket.trigger('api.events.list',
      {
        calendar_ids: calendarIds,
        start: start,
        end: end,
        event_type_filter: eventTypeFilter
      },
      success, failure)
  }

  // get calendar public events for calendar with id
  // events in range start to end both inclusive
  // date format YYYY-MM-DD
  calendarPublicEvents (calendarId, start, end, notes, eventTypeFilter, noFormat, success, failure) {
    this.state.websocket.trigger('api.calendars.public_events', {
      calendar_id: calendarId,
      start: start,
      end: end,
      notes: notes,
      event_type_filter: eventTypeFilter,
      no_format: noFormat
    }, success, failure)
  }

  calendar (calendarId, success, failure) {
    this.state.websocket.trigger('api.calendars.get', {
      calendar_id: calendarId
    }, success, failure)
  }

  // requires: can_do_most_stuff
  // dispatcher.trigger('api.calendars.copy_weeks', {calendar_ids: 5, source_date: '2021-11-01', destination_dates: ['2021-11-08','2021-11-15'], delete_existing: true, only_event_types: [], except_event_types: ['absence', 'presence']}, function(data) {console.log(data)})
  // dispatcher.trigger('api.calendars.copy_weeks', {calendar_ids: [5,12], source_date: '2021-11-01', destination_dates: ['2021-11-08','2021-11-15'], delete_existing: true, only_event_types: [], except_event_types: ['absence', 'presence']}, function(data) {console.log(data)})
  calendarCopyWeeks (calendarIds, sourceDate, destinationDates, deleteExisting, onlyEventTypes, exceptEventTypes, success, failure) {
    this.state.websocket.trigger('api.calendars.copy_weeks', {
      calendar_ids: calendarIds,
      source_date: sourceDate,
      destination_dates: destinationDates,
      delete_existing: deleteExisting,
      only_event_types: onlyEventTypes,
      except_event_types: exceptEventTypes
    }, success, failure)
  }

  // dispatcher.trigger('api.schools.subject_events.create',{school_id: 3, calendar_id: 129724, source_date: '2020-09-28', destination_dates: ['2020-43'], delete_existing: false, only_event_ids: [26492452]},function(data){console.log(data)})
  subjectEventsCreate (schoolId, calendarId, sourceDate, destinationDates, deleteExisting, onlyEventTypes, exceptEventTypes, onlySubjectIds, onlyEventIds, success, failure) {
    this.state.websocket.trigger('api.calendars.copy', {
      school_id: schoolId,
      calendar_id: calendarId,
      source_date: sourceDate,
      destination_dates: destinationDates,
      delete_existing: deleteExisting,
      only_event_types: onlyEventTypes,
      except_event_types: exceptEventTypes,
      only_subject_ids: onlySubjectIds,
      only_event_ids: onlyEventIds
    }, success, failure)
  }

  // dispatcher.trigger('api.calendars.copy_days', {school_id: 7272, calendar_ids: 218330, source_dates: ['2023-05-08','2023-05-09'], destination_dates: ['2023-05-10','2023-05-11','2023-05-12']}, function(data) {console.log(data)})
  calendarCopyDays (schoolId, calendarIds, sourceDates, destinationDates, success, failure) {
    this.state.websocket.trigger('api.calendars.copy_days', {
      school_id: schoolId,
      calendar_ids: calendarIds,
      source_dates: sourceDates,
      destination_dates: destinationDates
    }, success, failure)
  }

  // dispatcher.trigger('api.calendars.merge', {merge_calendar_id: 307774, calendar_id: 266788}, function(data){console.log(data)})
  mergeCalendar (schoolId, calendarId, mergeCalendarId, success, failure) {
    this.state.websocket.trigger('api.calendars.merge', {
      school_id: schoolId,
      calendar_id: calendarId,
      merge_calendar_id: mergeCalendarId
    }, success, failure)
  }

  // dispatcher.trigger('api.calendars.unmerge', {merge_calendar_id: 307774, calendar_id: 266788}, function(data){console.log(data)})
  unmergeCalendar (schoolId, calendarId, mergeCalendarId, success, failure) {
    this.state.websocket.trigger('api.calendars.unmerge', {
      school_id: schoolId,
      calendar_id: calendarId,
      merge_calendar_id: mergeCalendarId
    }, success, failure)
  }

  // dispatcher.trigger('api.calendars.merges', {school_id: 3}, function(data){console.log(data)})
  listCalendarMerges (schoolId, success, failure) {
    this.state.websocket.trigger('api.calendars.merges', {
      school_id: schoolId
    }, success, failure)
  }

  // dispatcher.trigger('api.schools.events.create', {school_id: 3, calendar_id: 5, calendar_ids: [5], start: '2018-08-14T10:00:00.000Z', end: '2018-08-14T12:00:00.000Z', subject_id: 10870}, function(data) {console.log(data)})
  // calendar_id must belong to school, required
  // calendar_ids must belong to school, required
  // subject_id must belong to calendar (calendar_id), required
  // start and end are time, required
  createEvent (schoolId, calendarId, calendarIds, subjectId, start, end, learningGoal, description, notesForStudents, teacherNotes, success, failure) {
    this.state.websocket.trigger('api.schools.events.create', {
      school_id: schoolId,
      calendar_id: calendarId,
      calendar_ids: calendarIds,
      subject_id: subjectId,
      start: start,
      end: end,
      learning_goal: learningGoal,
      description: description,
      notes_for_students: notesForStudents,
      teacher_notes: teacherNotes
    }, success, failure)
  }

  // requires: can_edit_own_notes, maybe in the future combined with can_do_most_stuff
  // dispatcher.trigger('api.schools.events.update',{school_id: 3, event_id: 9865192, event: {description: 'ASDF'}}, function(data) {console.log(data)})
  // eventParams: learning_goal, description, notes_for_students, teacher_notes, external_links, substitution_status
  updateEvent (schoolId, eventId, eventParams, success, failure) {
    this.state.websocket.trigger('api.schools.events.update', {
      school_id: schoolId,
      event_id: eventId,
      event: eventParams
    }, success, failure)
  }

  // requires: can_do_most_stuff
  // run in a transaction
  // dispatcher.trigger('api.events.update', {school_id: 3, updates: [{event_id: 1, calendar_id: 1, start_time: '2021-01-01 12:00Z', end_time: '2021-01-01 13:00Z'}]}, function(data) {console.log(data)}, failure);
  // dispatcher.trigger('api.events.update', {school_id: 3, updates:[{event_id: 29463741, calendar_ids: [], calendar_id: 5, add_substitute_calendar_id: 7, substitution_status: {'asdf':1}},{event_id: 29463742, calendar_id: 5, remove_substitute_calendar_id: 26372}]}, function(data) {console.log(data)}, failure);
  updateEvents (schoolId, updates, success, failure) {
    this.state.websocket.trigger('api.events.update', {
      school_id: schoolId,
      updates: updates
    }, success, failure)
  }

  // dispatcher.trigger('api.schools.events.delete',{school_id: 3, event_id: 9865192}, function(data) {console.log(data)})
  deleteEvent (schoolId, eventId, success, failure) {
    this.state.websocket.trigger('api.schools.events.delete', {
      school_id: schoolId,
      event_id: eventId
    }, success, failure)
  }

  // dispatcher.trigger('api.schools.events.list', {school_id: 3, date: '2018-06-04'}, function(data) {console.log(data)}, failure)
  listEvents (schoolId, date, success, failure) {
    this.state.websocket.trigger('api.schools.events.list', {
      school_id: schoolId,
      date: date
    }, success, failure)
  }

  listEventsForSchools (schoolIds, date, success, failure) {
    this.state.websocket.trigger('api.schools.events.list', {
      school_ids: schoolIds,
      date: date
    }, success, failure)
  }

  // check weeks for events with notes or substitutes before copying
  calendarCopyCheck (calendarId, dates, success, failure) {
    this.state.websocket.trigger('api.events.copy_check_weeks', {
      calendar_id: calendarId,
      dates: dates
    }, success, failure)
  }

  // split event
  splitEvent (eventId, splitTime, success, failure) {
    this.state.websocket.trigger('api.events.split', {
      event_id: eventId,
      split_time: splitTime
    }, success, failure)
  }

  // dispatcher.trigger('api.events.calendar_overlaps', {school_id: 3, event_ids:[25634747, 25634738]}, function(data) {console.log(data)}, failure);
  calendarOverlaps (eventIds, success, failure) {
    this.state.websocket.trigger('api.events.calendar_overlaps', {
      event_ids: eventIds
    }, success, failure)
  }

  // dispatcher.trigger('api.events.remove_substitution_of_user', {school_id: 3, event_ids: [29297399], user_id: 12, substitution_status: {'asdf':1}}, function(data) {console.log(data)}, failure)
  removeSubstitutionOfUser (schoolId, eventIds, userId, substitutionStatus, success, failure) {
    this.state.websocket.trigger('api.events.remove_substitution_of_user', {
      school_id: schoolId,
      event_ids: eventIds,
      user_id: userId,
      substitution_status: substitutionStatus
    }, success, failure)
  }

  getNotificationsUnreadBeforeId (count, onlyUnread, beforeId, success, failure) {
    this.state.websocket.trigger('api.notifications.list', {
      count: count,
      only_unread: onlyUnread,
      before_id: beforeId
    }, success, failure)
  }

  updateNotification (id, changes, success, failure) {
    this.state.websocket.trigger('api.notifications.update', {id: id, changes: changes}, success, failure)
  }

  markAllNotificationsAsRead (success, failure) {
    this.state.websocket.trigger('api.notifications.mark_all_as_read', {}, success, failure)
  }

  notificationsUnreadCount (success, failure) {
    this.state.websocket.trigger('api.notifications.unread_count', {}, success, failure)
  }

  getNotificationsList (count, success, failure) {
    this.state.websocket.trigger('api.notifications.list', {count: count}, success, failure)
  }

  getNotificationsListUnread (count, onlyUnread, success, failure) {
    this.state.websocket.trigger('api.notifications.list', {count: count, only_unread: onlyUnread}, success, failure)
  }

  getNotificationsBefore (count, beforeId, success, failure) {
    this.state.websocket.trigger('api.notifications.list', {count: count, before_id: beforeId}, success, failure)
  }

  // dispatcher.trigger('api.calendars.for_school', {school_id: 3}, function(data) {console.log(data)}, failure)
  calendarsForSchool (id, success, failure) {
    this.state.websocket.trigger('api.calendars.for_school', {school_id: id}, success)
  }

  deleteEventsRange (calendar, from, to, success, failure) {
    this.state.websocket.trigger('api.events.delete', {calendar: calendar, from: from, to: to}, success, failure)
  }

  // dispatcher.trigger('api.events.delete_calendar', {id: 59480130, calendar_id: 218345}, function(data) {console.log(data)})
  deleteEventCalendar (id, calendar, success, failure) {
    this.state.websocket.trigger('api.events.delete_calendar', {id: id, calendar_id: calendar}, success, failure)
  }

  // get current user
  getUser (success, failure) {
    this.state.websocket.trigger('api.users.get', {}, success)
  }

  // get user info
  showUser (userId, success, failure) {
    this.state.websocket.trigger('api.users.show', {user_id: userId}, success)
  }

  // get jwt token for current user
  getJwt (success, failure) {
    this.state.websocket.trigger('api.users.jwt', {}, success)
  }

  // docendo.updateUser({locale: 'da'}, success => console.log('success', success))
  updateUser (changes, success, failure) {
    this.state.websocket.trigger('api.users.update', changes, success)
  }

  // requires: can_manage_users
  // dispatcher.trigger('api.schools.users.update', {school_id: 3, user_id: 12, changes: {phone: '4512121212'}}, function(data) {console.log(data)})
  updateUsers (schoolId, userId, changes, success, failure) {
    this.state.websocket.trigger(
      'api.schools.users.update',
      {
        school_id: schoolId,
        user_id: userId,
        changes: changes
      },
      success,
      failure)
  }

  // dispatcher.trigger('api.schools.user_phone.update', {school_id: 3, user_id: 12, user: {unconfirmed_phone: '4512121212'}}, function(data) {console.log(data)})
  updateUserPhone (schoolId, userId, phone, success, failure) {
    this.state.websocket.trigger(
      'api.schools.user_phone.update',
      {
        school_id: schoolId,
        user_id: userId,
        user: {
          unconfirmed_phone: phone
        }
      },
      success,
      failure)
  }

  deleteUserPhone (schoolId, userId, success, failure) {
    this.state.websocket.trigger(
      'api.schools.user_phone.delete',
      {
        school_id: schoolId,
        user_id: userId
      },
      success,
      failure)
  }

  schoolVacationDaysCreate (school, date, success, failure) {
    this.state.websocket.trigger('api.school_vacation_days.create', {school: school, day: date}, success, failure)
  }

  schoolVacationDaysRead (school, success, failure) {
    this.state.websocket.trigger('api.school_vacation_days.read', {school: school}, success, failure)
  }

  schoolVacationDaysDelete (school, id, success, failure) {
    this.state.websocket.trigger('api.school_vacation_days.delete', {school: school, id: id}, success, failure)
  }

  schoolYearsRead (school, filter, sort, success, failure) {
    this.state.websocket.trigger('api.school_years.read', {
      school: school,
      filter: filter,
      sort: sort
    }, success, failure)
  }

  schoolYearsUpdate (school, id, changes, success, failure) {
    this.state.websocket.trigger('api.school_years.update', {
      school: school,
      id: id,
      changes: changes
    }, success, failure)
  }

  // School Subscribe
  schoolSubscribe (school, subscription, success, failure) {
    console.log('schoolSubscribe', subscription)
    this.state.websocket.trigger('api.schools.subscribe', {
      school_id: school,
      subscription: subscription
    }, success, failure)
  }

  // calendarId : id of calendar
  // week : week number in the format "2017W03"
  // from console
  // dispatcher.trigger('api.weeknotes.show', {calendar_id: 71980, week: '2018W02'}, function(data) {console.log(data)})
  weeknote (calendarId, week, success, failure) {
    this.state.websocket.trigger('api.weeknotes.show', {calendar_id: calendarId, week: week}, success, failure)
  }

  // calendarId : id of calendar
  // week : week number in the format "2017W03"
  // note : the note for the week
  weeknoteUpdate (calendarId, week, note, success, failure) {
    this.state.websocket.trigger('api.weeknotes.update', {
      calendar_id: calendarId,
      week: week,
      note: note
    }, success, failure)
  }

  bulkPresenceEvent (calendarId, toCreate, toUpdate, toDelete, success, failure) {
    this.state.websocket.trigger(
      'api.presence.update',
      {bulk_presence_event: {to_create: toCreate, to_update: toUpdate, to_delete: toDelete}},
      success,
      failure)
  }

  createPresenceForMany (schoolId, calendarIds, weekDates, events, success, failure) {
    this.state.websocket.trigger(
      'api.presence.create',
      {
        school_id: schoolId,
        calendar_ids: calendarIds,
        week_dates: weekDates,
        events: events
      }, success, failure)
  }

  // from console:
  // dispatcher.trigger('api.schools.user_events.read', {school_id: 3, from_datetime: '2017-12-04T00:00:00.000Z', to_datetime: '2017-12-10T00:00:00.000Z', user_ids_filter: [12,13,15]}, function(data) {console.log(data)})
  schoolEvents (schoolId, from, to, userIdsFilter, eventTypeFilter, success, failure) {
    this.state.websocket.trigger(
      'api.school_user_events.read',
      {
        school_id: schoolId,
        from_datetime: from,
        to_datetime: to,
        user_ids_filter: userIdsFilter,
        event_type_filter: eventTypeFilter
      },
      success,
      failure)
  }

  // requires: can_do_most_stuff
  // from console:
  // dispatcher.trigger('api.schools.users.read',{school_id: 3, user_ids_filter: [12]}, function(data) {console.log(data)})
  schoolUsers (schoolId, userIdsFilter, success, failure) {
    this.state.websocket.trigger(
      'api.schools.users.read',
      {
        school_id: schoolId,
        user_ids_filter: userIdsFilter
      },
      success,
      failure)
  }

  // dispatcher.trigger('api.schools.users.read2',{school_id: 3}, function(data) {console.log(data)})
  schoolUsers2 (schoolId, success, failure) {
    this.state.websocket.trigger(
      'api.schools.users.read2',
      {
        school_id: schoolId
      },
      success,
      failure)
  }

  // requires: can_manage_users
  // takes: name, email, unilogin, feide
  // from console:
  // dispatcher.trigger('api.schools.users.create',{school_id: 3, users: [{name: "Mikkel", email:"mikkel@docendo.dk"}]}, function(data) {console.log(data)})
  schoolUsersCreate (schoolId, users, success, failure) {
    this.state.websocket.trigger(
      'api.schools.users.create',
      {
        school_id: schoolId,
        users: users
      },
      success,
      failure
    )
  }

  // requires: can_manage_users
  // dispatcher.trigger('api.schools.users.assign_permission_set',{'school_id':3, 'user_id':12, 'permission_set_id':3007},function(data){console.log(JSON.stringify(data))})
  schoolUsersAssignPermissionSet (schoolId, userId, permissionSetId, success, failure) {
    this.state.websocket.trigger(
      'api.schools.users.assign_permission_set',
      {
        school_id: schoolId,
        user_id: userId,
        permission_set_id: permissionSetId
      },
      success,
      failure
    )
  }

  // from console:
  // dispatcher.trigger('api.schools.event_serials.list', {school_id: 3, date: '2021-02-26'}, function(data) {console.log(data)}, failure);
  schoolEventSerialsList (schoolId, date, success, failure) {
    this.state.websocket.trigger(
      'api.schools.event_serials.list',
      {
        school_id: schoolId,
        date: date
      },
      success,
      failure)
  }

  // from console:
  // dispatcher.trigger('api.schools.event_serials.create', {school_id: 3, calendar_id: 7, subject_id:27613, from_date: "2018-01-10", to_date: "2018-01-12", from_time:"2017-09-12T08:00:00.000+02:00", to_time:"2017-09-12T16:00:00.000+02:00"}, function(data) {console.log(data)}, failure);
  schoolEventSerialsCreate (schoolId, calendarId, subjectId, fromDate, toDate, fromTime, toTime, ongoing, internalNote, success, failure) {
    this.state.websocket.trigger(
      'api.schools.event_serials.create',
      {
        school_id: schoolId,
        calendar_id: calendarId,
        subject_id: subjectId,
        from_date: fromDate, // "2018-01-10"
        to_date: toDate, //  "2018-01-12"
        from_time: fromTime, // "2018-01-10T08:00:00.000+02:00" only clock is used
        to_time: toTime, // "2018-01-12T16:00:00.000+02:00" only clock is used
        ongoing: ongoing,
        internal_note: internalNote
      },
      success,
      failure)
  }

  // from console:
  // dispatcher.trigger('api.schools.event_serials.read', {school_id: 3, id: 1}, function(data) {console.log(data)}, failure);
  schoolEventSerialsRead (schoolId, eventSerialId, success, failure) {
    this.state.websocket.trigger(
      'api.schools.event_serials.read',
      {
        school_id: schoolId,
        id: eventSerialId
      },
      success,
      failure)
  }

  // from console:
  // dispatcher.trigger('api.schools.event_serials.update', {school_id: 3, calendar_id: 7, subject_id:27613, from_date: "2018-01-10", to_date: "2018-01-12", from_time:"2017-09-12T08:00:00.000+02:00", to_time:"2017-09-12T16:00:00.000+02:00"}, function(data) {console.log(data)}, failure);
  schoolEventSerialsUpdate (schoolId, eventSerialId, calendarId, subjectId, fromDate, toDate, fromTime, toTime, ongoing, internalNote, success, failure) {
    this.state.websocket.trigger(
      'api.schools.event_serials.update',
      {
        id: eventSerialId,
        school_id: schoolId,
        calendar_id: calendarId,
        subject_id: subjectId,
        from_date: fromDate, // "2018-01-10"
        to_date: toDate, //  "2018-01-12"
        from_time: fromTime, // "2018-01-10T08:00:00.000+02:00" only clock is used
        to_time: toTime, // "2018-01-12T16:00:00.000+02:00" only clock is used
        ongoing: ongoing,
        internal_note: internalNote
      },
      success,
      failure)
  }

  // from console:
  // dispatcher.trigger('api.schools.event_serials.destroy', {school_id: 3, id: 1}, function(data) {console.log(data)}, failure);
  schoolEventSerialsDelete (schoolId, eventSerialId, success, failure) {
    this.state.websocket.trigger(
      'api.schools.event_serials.destroy',
      {
        school_id: schoolId,
        id: eventSerialId
      },
      success,
      failure)
  }

  // requires: can_do_most_stuff
  // from console:
  // dispatcher.trigger('api.schools.absence_subjects.list', {school_id: 3}, function(data) {console.log(data)}, failure);
  schoolAbsenceSubjectsList (schoolId, includeArchived, success, failure) {
    this.state.websocket.trigger(
      'api.schools.absence_subjects.list',
      {
        school_id: schoolId,
        include_archived: includeArchived
      },
      success,
      failure)
  }

  // requires: can_manage_absence_reasons
  // from console:
  // dispatcher.trigger('api.schools.absence_subjects.create', {school_id: 3, name: 'Mentalt fraværende', color: '#ff0000'}, function(data) {console.log(data)}, failure);
  // color is optional, defaults to red
  schoolAbsenceSubjectsCreate (schoolId, name, color, defaultPrivate, success, failure) {
    this.state.websocket.trigger(
      'api.schools.absence_subjects.create',
      {
        school_id: schoolId,
        name: name,
        color: color,
        default_private: defaultPrivate
      },
      success,
      failure)
  }

  // requires: can_manage_absence_reasons
  // from console:
  // dispatcher.trigger('api.schools.absence_subjects.update', {school_id: 3, name: 'Mentalt fraværende', color: '#ff0000'}, function(data) {console.log(data)}, failure);
  // color is optional, defaults to red
  schoolAbsenceSubjectsUpdate (id, schoolId, name, color, defaultPrivate, success, failure) {
    this.state.websocket.trigger(
      'api.schools.absence_subjects.update',
      {
        id: id,
        school_id: schoolId,
        name: name,
        color: color,
        default_private: defaultPrivate
      },
      success,
      failure)
  }

  // requires: can_manage_absence_reasons
  // from console:
  // dispatcher.trigger('api.schools.absence_subjects.archive', {school_id: 3, id: 1}, function(data) {console.log(data)}, failure);
  schoolAbsenceSubjectsArchive (schoolId, id, success, failure) {
    this.state.websocket.trigger(
      'api.schools.absence_subjects.archive',
      {
        school_id: schoolId,
        id: id
      },
      success,
      failure)
  }

  // requires: can_manage_absence_reasons
  // from console:
  // dispatcher.trigger('api.schools.absence_subjects.unarchive', {school_id: 3, id: 1}, function(data) {console.log(data)}, failure);
  schoolAbsenceSubjectsUnarchive (schoolId, id, success, failure) {
    this.state.websocket.trigger(
      'api.schools.absence_subjects.unarchive',
      {
        school_id: schoolId,
        id: id
      },
      success,
      failure)
  }

  // type can be: class, other, room, merge
  // year should be specified when type is 'class' or 'other'
  // template is only available for type 'class'
  // from console:
  // dispatcher.trigger('api.calendars.bulk_create',{school_id: 3, calendars: [{name: "2.a", type: "class", year: "2018-2019", template: "2"},{name:"Idræt", type: "room"}]}, function(data) {console.log(data)})
  schoolBulkCreateCalendars (schoolId, schoolYearId, calendars, success, failure) {
    this.state.websocket.trigger(
      'api.calendars.bulk_create',
      {
        school_id: schoolId,
        schoolYearId: schoolYearId,
        calendars: calendars
      },
      success,
      failure)
  }

  // dispatcher.trigger('api.calendars.bulk_update',{school_id: 3, calendars: [{calendar_id: 1, published_until: '2021-11-16', anonymous_access: true}]}, function(data) {console.log(data)})
  schoolBulkUpdateCalendars (schoolId, calendars, success, failure) {
    this.state.websocket.trigger(
      'api.calendars.bulk_update',
      {
        school_id: schoolId,
        calendars: calendars
      },
      success,
      failure)
  }

  // requires: can_manage_calendars
  // from console:
  // dispatcher.trigger('api.calendars.update',{school_id: 3, calendar_id: 83765, calendar: {name:'asdf', archived: true}}, function(data) {console.log(data)})
  schoolCalendarsUpdate (schoolId, calendarId, changes, success, failure) {
    this.state.websocket.trigger(
      'api.calendars.update',
      {
        school_id: schoolId,
        calendar_id: calendarId,
        calendar: changes
      },
      success,
      failure)
  }

  // from console:
  // dispatcher.trigger('api.calendars.delete',{school_id: 3, calendar_id: 83765}, function(data) {console.log(data)})
  schoolCalendarsDelete (schoolId, calendarId, success, failure) {
    this.state.websocket.trigger(
      'api.calendars.delete',
      {
        school_id: schoolId,
        calendar_id: calendarId
      },
      success,
      failure)
  }

  // dispatcher.trigger('api.subject_norms.index_school',{school_id: 3}, function(data) {console.log(data)})
  // requires: can_manage_calendars
  subjectNormsSchool (schoolId, success, failure) {
    this.state.websocket.trigger(
      'api.subject_norms.index',
      {
        school_id: schoolId
      }, success, failure)
  }

  eventAddSubstitute (event, added, subFor, success, failure) {
    this.state.websocket.trigger(
      'api.events.add_substitute', {
        event: event,
        user: added,
        substitute_for_user: subFor
      }, success, failure)
  }

  // from console: dispatcher.trigger('api.eventRemoveSubstitute', {school_id: 3}, function(data) {console.log(data)})
  eventRemoveSubstitute (event, user, subFor, success, failure) {
    this.state.websocket.trigger(
      'api.events.remove_substitute', {
        event: event,
        user: user,
        substitute_for_user: subFor
      }, success, failure)
  }

  // requires: can_do_most_stuff
  // list the existing tags for the school
  // from console: dispatcher.trigger('api.schools.tags.index', {school_id: 3}, function(data) {console.log(data)})
  schoolTags (schoolId, success, failure) {
    this.state.websocket.trigger(
      'api.schools.tags.index', {
        school_id: schoolId
      }, success, failure)
  }

  // requires: can_manage_users
  // add tags for users
  // from console: dispatcher.trigger('api.schools.tags.bulk_create', {school_id: 3, tags: ['team 1', 'pæd'], user_ids:[12,15]}, function(data) {console.log(data)})
  schoolTagsBulkCreate (schoolId, tags, userIds, success, failure) {
    this.state.websocket.trigger(
      'api.schools.tags.bulk_create', {
        school_id: schoolId,
        tags: tags,
        user_ids: userIds
      }, success, failure)
  }

  // requires: can_manage_users
  // delete tags for users
  // from console: dispatcher.trigger('api.schools.tags.bulk_delete', {school_id: 3, tags: ['team 1', 'pæd'], user_ids:[12,15]}, function(data) {console.log(data)})
  schoolTagsBulkDelete (schoolId, tags, userIds, success, failure) {
    this.state.websocket.trigger(
      'api.schools.tags.bulk_delete', {
        school_id: schoolId,
        tags: tags,
        user_ids: userIds
      }, success, failure)
  }

  // get assigned hours for a school for a year
  // dispatcher.trigger('api.schools.assigned_hours.read',{school_id: 3, year: '2018-2019'}, function(data) {console.log(data)})
  schoolAssignedHours (schoolId, year, userIdsFilter, success, failure) {
    this.state.websocket.trigger(
      'api.schools.assigned_hours.read', {
        school_id: schoolId,
        year: year,
        user_ids_filter: userIdsFilter
      }, success, failure)
  }

  schoolRecalculateAll (schoolId, success, failure) {
    this.state.websocket.trigger(
      'api.schools.recalculate.recalculate_all', {
        school_id: schoolId
      }, success, failure)
  }

  // get actual hours for a school for a year
  // dispatcher.trigger('api.schools.actual_hours.read',{school_id: 3, from_datetime: '2017-08-01 00:00', to_datetime: '2018-08-01 00:00'}, function(data) {console.log(data)})
  schoolActualHours (schoolId, fromDateTime, toDateTime, userIdsFilter, success, failure) {
    this.state.websocket.trigger(
      'api.schools.actual_hours.read', {
        school_id: schoolId,
        from_datetime: fromDateTime,
        to_datetime: toDateTime,
        user_ids_filter: userIdsFilter
      }, success, failure)
  }

  // get user year
  // dispatcher.trigger('api.schools.user_years.read',{school_id: 3, user_id: 12, year:'2019-2020'}, function(data) {console.log(data)})
  schoolUserYearRead (schoolId, userId, year, success, failure) {
    this.state.websocket.trigger(
      'api.schools.user_years.read', {
        school_id: schoolId,
        user_id: userId,
        year: year
      }, success, failure)
  }

  // get all user years
  // dispatcher.trigger('api.schools.user_years.list',{school_id: 3, school_year_id: 12}, function(data) {console.log(data)})
  schoolUserYearsList (schoolId, schoolYearId, userId, success, failure) {
    this.state.websocket.trigger(
      'api.schools.user_years.list', {
        school_id: schoolId,
        school_year_id: schoolYearId,
        user_id: userId
      }, success, failure)
  }

  // update user year
  // dispatcher.trigger('api.schools.user_years.update',{school_id: 3, user_id: 12, year:'2019-2020', substitute_pool_hours: 30, agreements: 'Something'}, function(data) {console.log(data)})
  schoolUserYearUpdate (schoolId, userId, year, data, success, failure) {
    this.state.websocket.trigger(
      'api.schools.user_years.update', {
        school_id: schoolId,
        user_id: userId,
        year: year,
        user_data: data
      }, success, failure)
  }

  // bulk update user year
  // as above but bulk data is an array like [{user_id: 1, data: {}}, {user_id: 2, data: {}}]
  bulkSchoolUserYearUpdate (schoolId, year, data, success, failure) {
    this.state.websocket.trigger(
      'api.schools.user_years.bulk_update', {
        school_id: schoolId,
        user_id: null,
        year: year,
        users_data: data
      }, success, failure)
  }

  // dispatcher.trigger('api.schools.availabilities.list',{school_id: 3, calendar_type: 'user', start_time: '2018-06-20 07:00', end_time: '2018-06-20 08:00'}, function(data) {console.log(data)})
  // dispatcher.trigger('api.schools.availabilities.list',{school_id: 3, calendar_type: 'klass', start_time: '2018-06-20 07:00', end_time: '2018-06-20 08:00'}, function(data) {console.log(data)})
  schoolAvailabilities (schoolId, calendarType, startTime, endTime, success, failure) {
    this.state.websocket.trigger(
      'api.schools.availabilities.list', {
        school_id: schoolId,
        calendar_type: calendarType,
        start_time: startTime,
        end_time: endTime
      }, success, failure)
  }

  // dispatcher.trigger('api.schools.substitute_day_notes.show', {school_id: 3, note: {day: '2020-02-15'}}, function(data) {console.log(data)})
  schoolSubstituteDayNoteRead (schoolId, day, success, failure) {
    this.state.websocket.trigger(
      'api.schools.substitute_day_notes.show', {
        school_id: schoolId,
        note: {
          day: day
        }
      }, success, failure)
  }

  // dispatcher.trigger('api.schools.substitute_day_notes.update', {school_id: 3, note: {day: '2020-02-15', note: 'plot'}}, function(data) {console.log(data)})
  schoolSubstituteDayNoteUpdate (schoolId, day, note, success, failure) {
    this.state.websocket.trigger(
      'api.schools.substitute_day_notes.update', {
        school_id: schoolId,
        note: {
          day: day,
          note: note
        }
      }, success, failure)
  }

  // dispatcher.trigger('api.schools.substitute_hours.index', {school_id: 3}, function(data) {console.log(data)})
  schoolSubstituteHours (schoolId, success, failure) {
    this.state.websocket.trigger(
      'api.schools.substitute_hours.index', {
        school_id: schoolId
      }, success, failure)
  }

  // dispatcher.trigger('api.schools.sms.send', {school_id: 3, user_id: 12, message:'tester'},function(data) {console.log(data)})
  // does not deliver in test or development environment
  countSms (schoolId, success, failure) {
    this.state.websocket.trigger(
      'api.schools.sms.count', {
        school_id: schoolId
      }, success, failure
    )
  }

  // dispatcher.trigger('api.schools.sms.ship', {school_id: 3, user_ids: [12,13], message:'tester'},function(data) {console.log(data)})
  // does not deliver in test or development environment
  sendSmses (schoolId, userIds, message, success, failure) {
    this.state.websocket.trigger(
      'api.schools.sms.ship', {
        school_id: schoolId,
        user_ids: userIds,
        message: message
      }, success, failure
    )
  }

  pastSmses (schoolId, success, failure) {
    this.state.websocket.trigger(
      'api.schools.sms.past', {
        school_id: schoolId
      }, success, failure
    )
  }

  // dispatcher.trigger('api.schools.email.ship', {school_id: 3, user_ids: [12], subject: 'titel', message:'tester'},function(data) {console.log(data)})
  // does not deliver in test or development environment
  sendEmails (schoolId, userIds, subject, message, success, failure) {
    this.state.websocket.trigger(
      'api.schools.email.ship', {
        school_id: schoolId,
        user_ids: userIds,
        subject: subject,
        message: message
      }, success, failure
    )
  }

  // deprecated, use message_templates instead
  // dispatcher.trigger('api.schools.sms_templates.read', {school_id: 3}, function(data){console.log(data)},function(data){console.log(data)})
  readSmsTemplates (schoolId, success, failure) {
    this.state.websocket.trigger(
      'api.schools.sms_templates.read', {
        school_id: schoolId
      }, success, failure
    )
  }

  // dispatcher.trigger('api.schools.message_templates.create', {school_id: 3, title: 'test', body: 'tester', messageType: 'email'}, function(data){console.log(data)},function(data){console.log(data)})
  createMessageTemplate (schoolId, title, body, messageType, success, failure) {
    this.state.websocket.trigger(
      'api.schools.message_templates.create', {
        school_id: schoolId,
        title: title,
        body: body,
        message_type: messageType
      }, success, failure
    )
  }

  // dispatcher.trigger('api.schools.message_templates.read', {school_id: 3}, function(data){console.log(data)},function(data){console.log(data)})
  readMessageTemplates (schoolId, success, failure) {
    this.state.websocket.trigger(
      'api.schools.message_templates.read', {
        school_id: schoolId
      }, success, failure
    )
  }

  // dispatcher.trigger('api.schools.message_templates.update', {school_id: 3, id: 1, title: 'tester', body: 'tester mere'}, function(data){console.log(data)},function(data){console.log(data)})
  updateMessageTemplate (schoolId, id, title, body, messageType, success, failure) {
    this.state.websocket.trigger(
      'api.schools.message_templates.update', {
        school_id: schoolId,
        id: id,
        title: title,
        body: body,
        message_type: messageType
      }, success, failure
    )
  }

  // dispatcher.trigger('api.schools.message_templates.delete', {school_id: 3, id:1}, function(data){console.log(data)},function(data){console.log(data)})
  deleteMessageTemplate (schoolId, id, success, failure) {
    this.state.websocket.trigger(
      'api.schools.message_templates.delete', {
        school_id: schoolId,
        id: id
      }, success, failure
    )
  }

  // dispatcher.trigger('api.schools.events.changes', {school_id: 3, event_id: 14015057}, function(data){console.log(data)})
  eventChanges (schoolId, eventId, success, failure) {
    this.state.websocket.trigger(
      'api.schools.events.changes', {
        school_id: schoolId,
        event_id: eventId
      }, success, failure
    )
  }

  // dispatcher.trigger('api.subjects.create', {name, color, calendarId, defaultDuration, hours, subjectType, schoolId, schoolYearId, calendarIds, subjectCode}, function(data){console.log(data)})
  createSubject (name, color, calendarId, defaultDuration, preparation, hours, subjectType, schoolId, schoolYearId, calendarIds, subjectCode, away, success, failure) {
    this.state.websocket.trigger(
      'api.subjects.create', {
        name: name,
        color: color,
        calendar_id: calendarId,
        default_duration: defaultDuration,
        preparation: preparation,
        hours: hours,
        subject_type: subjectType,
        school_id: schoolId,
        school_year_id: schoolYearId,
        calendar_ids: calendarIds,
        subject_code: subjectCode,
        away: away
      }, success, failure
    )
  }

  // dispatcher.trigger('api.subjects.read', {school_id: 3, school_year_id: 3428}, function(data){console.log(data)})
  readSubjects (schoolId, schoolYearId, userId, success, failure) {
    this.state.websocket.trigger(
      'api.subjects.read', {
        school_id: schoolId,
        school_year_id: schoolYearId,
        user_id: userId
      }, success, failure
    )
  }

  // dispatcher.trigger('api.subjects.show', {id: 12345}, function(data){console.log(data)})
  showSubject (subjectId, success, failure) {
    this.state.websocket.trigger(
      'api.subjects.show', {
        id: subjectId
      }, success, failure
    )
  }

  updateSubject (id, name, color, calendarId, calendarIds, defaultDuration, preparation, hours, subjectType, schoolId, schoolYearId, subjectCode, away, defaultPrivate, success, failure) {
    this.state.websocket.trigger(
      'api.subjects.update', {
        id: id,
        name: name,
        color: color,
        calendar_id: calendarId,
        default_duration: defaultDuration,
        hours: hours,
        subject_type: subjectType,
        school_id: schoolId,
        school_year_id: schoolYearId,
        calendar_ids: calendarIds,
        subject_code: subjectCode,
        preparation: preparation,
        away: away,
        default_private: defaultPrivate
      }, success, failure
    )
  }

  // dispatcher.trigger('api.subjects.show', {id: 532945}, function(data){console.log(data)})
  // dispatcher.trigger('api.subjects.delete', {id: 528772, school_id:23481, school_year_id:12567}, function(data){console.log(data)})
  deleteSubject (id, schoolId, schoolYearId, success, failure) {
    this.state.websocket.trigger(
      'api.subjects.delete', {
        id: id,
        school_id: schoolId,
        school_year_id: schoolYearId
      }, success, failure
    )
  }

  // dispatcher.trigger('api.subjects.set_hours',{hours:32, 'school_id':3, 'id':256066, 'user_id':12, 'school_year_id':3438},function(data){console.log(JSON.stringify(data))})
  setHoursForTeacherOnSubject (id, schoolId, schoolYearId, calendarId, hours, success, failure) {
    this.state.websocket.trigger(
      'api.subjects.set_hours', {
        id: id,
        school_id: schoolId,
        school_year_id: schoolYearId,
        hours: hours,
        calendar_id: calendarId
      },
      success, failure
    )
  }

  // dispatcher.trigger('api.audit.subject', {school_id: 3, subject_id: 250009}, function(data){console.log(data)})
  auditSubject (schoolId, subjectId, success, failure) {
    this.state.websocket.trigger(
      'api.audit.subject', {
        subject_id: subjectId,
        school_id: schoolId
      }, success, failure
    )
  }

  // dispatcher.trigger('api.audit.deleted_events_by_subject', {school_id: 7272, subject_id: 573677}, function(data){console.log(data)})
  auditDeletedEventsBySubject (schoolId, subjectId, success, failure) {
    this.state.websocket.trigger(
      'api.audit.deleted_events_by_subject', {
        subject_id: subjectId,
        school_id: schoolId
      }, success, failure
    )
  }

  // dispatcher.trigger('api.audit.weeknote', {school_id: 3, weeknote_id: 1}, function(data){console.log(data)})
  auditWeeknote (schoolId, weeknoteId, success, failure) {
    this.state.websocket.trigger(
      'api.audit.weeknote', {
        school_id: schoolId,
        weeknote_id: weeknoteId
      }, success, failure
    )
  }

  // dispatcher.trigger('api.audit.user', {}, function(data){console.log(data)})
  auditUser (success, failure) {
    this.state.websocket.trigger(
      'api.audit.user', {}, success, failure
    )
  }

  auditLogSchool (schoolId, success, failure) {
    this.state.websocket.trigger(
      'api.audit_logs.school', {
        school_id: schoolId
      }, success, failure
    )
  }

  auditLogUser (schoolId, userId, success, failure) {
    this.state.websocket.trigger(
      'api.audit_logs.user', {
        school_id: schoolId,
        user_id: userId
      }, success, failure
    )
  }

  // dispatcher.trigger('api.audit_logs.calendar', {school_id: 33473, calendar_id: 232951, function(data){console.log(data)})
  auditLogCalendar (schoolId, calendarId, success, failure) {
    this.state.websocket.trigger(
      'api.audit_logs.calendar', {
        school_id: schoolId,
        calendar_id: calendarId
      }, success, failure
    )
  }

  // dispatcher.trigger('api.schools.tasks.create', {school_id: 3, school_year_id: 3438, task: {name: 'test', ... }}, function(data){console.log(data)})
  createTask (schoolId, schoolYearId, subjectType, hours, name, color, defaultDuration, preparation, belongsToCalendars, userCalendars, canSchedule, inUserCalendar, success, failure) {
    this.state.websocket.trigger(
      'api.schools.tasks.create', {
        school_id: schoolId,
        school_year_id: schoolYearId,
        task: {
          subject_type: subjectType,
          hours: hours,
          name: name,
          color: color,
          default_duration: defaultDuration,
          preparation: preparation,
          belongs_to_calendars: belongsToCalendars,
          user_calendars: userCalendars,
          can_schedule: canSchedule,
          in_user_calendar: inUserCalendar
        }
      }, success, failure
    )
  }

  // dispatcher.trigger('api.schools.tasks.read', {school_id: 3, school_year_id: 3438}, function(data){console.log(data)})
  readTasks (schoolId, schoolYearId, userId, success, failure) {
    this.state.websocket.trigger(
      'api.schools.tasks.read', {
        school_id: schoolId,
        school_year_id: schoolYearId,
        user_id: userId
      }, success, failure
    )
  }

  // dispatcher.trigger('api.schools.tasks.update', {school_id: 3, school_year_id: 3438, id: 'something', task: {name: 'tester', ...}}, function(data){console.log(data)})
  updateTask (schoolId, schoolYearId, id, name, color, hours, defaultDuration, preparation, belongsToCalendars, userCalendars, inUserCalendar, success, failure) {
    this.state.websocket.trigger(
      'api.schools.tasks.update', {
        school_id: schoolId,
        school_year_id: schoolYearId,
        id: id,
        task: {
          hours: hours,
          name: name,
          color: color,
          default_duration: defaultDuration,
          preparation: preparation,
          belongs_to_calendars: belongsToCalendars,
          user_calendars: userCalendars,
          in_user_calendar: inUserCalendar
        }
      }, success, failure
    )
  }

  // dispatcher.trigger('api.schools.tasks.delete', {school_id: 3, school_year_id: 3438, id: 'something'}, function(data){console.log(data)})
  deleteTask (schoolId, schoolYearId, id, success, failure) {
    this.state.websocket.trigger(
      'api.schools.tasks.delete', {
        school_id: schoolId,
        school_year_id: schoolYearId,
        id: id
      }, success, failure
    )
  }

  // dispatcher.trigger('api.exports.create', {school_id: 3, school_year_id: 3438}, function(data){console.log(data)})
  createExport (schoolId, schoolYearId, success, failure) {
    this.state.websocket.trigger(
      'api.exports.create', {
        school_id: schoolId,
        school_year_id: schoolYearId
      }, success, failure
    )
  }

  // list available permissions
  // requires: can_manage_users
  // dispatcher.trigger('api.schools.permission_sets.permissions',{'school_id':3},function(data){console.log(JSON.stringify(data))})
  permissionSetsPermissions (schoolId, success, failure) {
    this.state.websocket.trigger('api.schools.permission_sets.permissions', {
      school_id: schoolId
    }, success, failure)
  }

  // requires: can_manage_users
  // dispatcher.trigger('api.schools.permission_sets.read',{'school_id':3},function(data){console.log(JSON.stringify(data))})
  permissionSetsRead (schoolId, success, failure) {
    this.state.websocket.trigger('api.schools.permission_sets.read', {
      school_id: schoolId
    }, success, failure)
  }

  // permissions is an array
  // requires: can_manage_users
  // dispatcher.trigger('api.schools.permission_sets.create',{'school_id':3, 'permission_set':{'name':'Test', 'permissions':['can_setup_aula']}},function(data){console.log(JSON.stringify(data))})
  permissionSetsCreate (schoolId, name, permissions, success, failure) {
    this.state.websocket.trigger('api.schools.permission_sets.create', {
      school_id: schoolId,
      permission_set: {
        name: name,
        permissions: permissions
      }
    }, success, failure)
  }

  // permissions is an array
  // requires: can_manage_users
  permissionSetsUpdate (schoolId, id, name, permissions, success, failure) {
    this.state.websocket.trigger('api.schools.permission_sets.update', {
      school_id: schoolId,
      permission_set: {
        id: id,
        name: name,
        permissions: permissions
      }
    }, success, failure)
  }

  // permission set can not have any users
  // requires: can_manage_users
  // dispatcher.trigger('api.schools.permission_sets.delete',{'school_id':3, 'permission_set': {'id': 2}},function(data){console.log(JSON.stringify(data))},function(data){console.log(JSON.stringify(data))})
  permissionSetsDelete (schoolId, id, success, failure) {
    this.state.websocket.trigger('api.schools.permission_sets.delete', {
      school_id: schoolId,
      permission_set: {
        id: id
      }
    }, success, failure)
  }

  // requires: can_manage_users
  // dispatcher.trigger('api.employments.read', {school_id: 3}, function(data) {console.log(data.result)}, failure);
  employmentsForSchool (schoolId, success, failure) {
    this.state.websocket.trigger('api.employments.read', {
      school_id: schoolId
    }, success, failure)
  }

  // requires: can_manage_users
  // dispatcher.trigger('api.employments.read', {school_id: 3, user_id: 12}, function(data) {console.log(data.result)}, failure);
  employmentsForSchoolForUser (schoolId, userId, success, failure) {
    this.state.websocket.trigger('api.employments.read', {
      school_id: schoolId,
      user_id: userId
    }, success, failure)
  }

  // requires: can_manage_users
  // dispatcher.trigger('api.employments.bulk_create', {school_id: 3, user_ids: [12,13], employmentTypeId: 1}, function(data) {console.log(data)}, failure);
  bulkCreateEmployment (schoolId, userIds, titles, manualSalary, success, failure) {
    this.state.websocket.trigger('api.employments.bulk_create', {
      school_id: schoolId,
      user_ids: userIds,
      titles: titles,
      manual_salary: manualSalary
    }, success, failure)
  }

  // requires: can_manage_users
  // dispatcher.trigger('api.employments.create', {school_id: 3, user_id: 12, employment: {title: 'Test', employment_number: '001234', category: 'teacher', employmentTypeId: 1}}, function(data) {console.log(data)}, failure);
  createEmployment (schoolId, userId, employmentNumber, employmentTypeId, success, failure) {
    this.state.websocket.trigger('api.employments.create', {
      school_id: schoolId,
      user_id: userId,
      employment: {
        employment_number: employmentNumber,
        employment_type_id: employmentTypeId
      }
    }, success, failure)
  }

  // requires: can_manage_users
  // dispatcher.trigger('api.employments.delete', {school_id: 3, user_id: 12, id: 1}, function(data) {console.log(data)}, failure);
  deleteEmployment (schoolId, userId, employmentId, success, failure) {
    this.state.websocket.trigger('api.employments.delete', {
      school_id: schoolId,
      user_id: userId,
      id: employmentId
    }, success, failure)
  }

  updateEmployment (schoolId, userId, employmentId, manualSalary, defaultLoenart, defaultLoebenummer, defaultOmkostningssted, employmentTemplateId, salaryCodeId, success, failure) {
    this.state.websocket.trigger('api.employments.update', {
      school_id: schoolId,
      id: employmentId,
      employment: {
        user_id: userId,
        manual_salary: manualSalary,
        default_loenart: defaultLoenart,
        default_loebenummer: defaultLoebenummer,
        employment_template_id: employmentTemplateId,
        salary_code_id: salaryCodeId,
        default_omkostningssted: defaultOmkostningssted
      }
    }, success, failure)
  }

  assignEmploymentTemplateToEmployment (schoolId, employmentTemplateId, employmentIds, success, failure) {
    this.state.websocket.trigger('api.employments.bulk_assign_template', {
      school_id: schoolId,
      employment_template_id: employmentTemplateId,
      employment_ids: employmentIds
    }, success, failure)
  }

  // requires: can_manage_salary
  // dispatcher.trigger('api.salaries.read', {school_id: 3, school_ids: [3,4], from_date: '2024-09-01', to_date: '2024-09-30'}, function(data) {console.log(data)}, failure)
  salaryDays (schoolId, schoolIds, fromDate, toDate, success, failure) {
    this.state.websocket.trigger('api.salaries.read', {
      school_id: schoolId,
      school_ids: schoolIds,
      from_date: fromDate,
      to_date: toDate
    }, success, failure)
  }

  // requires: can_manage_salary
  // dispatcher.trigger('api.salaries.update', {school_id: 3, school_ids: [3,4], day: '2021-06-04', day: ...}, function(data) {console.log(data)}, failure)
  salaryDayUpdate (schoolId, schoolIds, day, success, failure) {
    this.state.websocket.trigger('api.salaries.update', {
      school_id: schoolId,
      school_ids: schoolIds,
      day: day
    }, success, failure)
  }

  // requires: can_manage_salary
  // dispatcher.trigger('api.salaries.opus_read', {school_id: 3, school_ids: [3,4], from_date: '2024-09-01', to_date: '2024-09-30', user_id: 1}, function(data) {console.log(data)}, failure)
  salaryOpusRead (schoolId, schoolIds, fromDate, toDate, userId, success, failure) {
    this.state.websocket.trigger('api.salaries.opus_read', {
      school_id: schoolId,
      school_ids: schoolIds,
      from_date: fromDate,
      to_date: toDate,
      user_id: userId
    }, success, failure)
  }

  // dispatcher.trigger('api.salary_codes.index', {school_id: 3}, function(data) {console.log(data)}, failure)
  // requires: can_manage_salary
  salaryCodes (schoolId, success, failure) {
    this.state.websocket.trigger('api.salary_codes.index', {
      school_id: schoolId
    }, success, failure)
  }

  // dispatcher.trigger('api.salary_codes.create', {school_id: 3, salary_code: { name: 'Normaltimer', loenart: '1234', tillaegsnummer: '123321' } }, function(data) {console.log(data)}, failure)
  // requires: can_manage_salary
  createSalaryCode (schoolId, name, loenart, tillaegsnummer, success, failure) {
    this.state.websocket.trigger('api.salary_codes.create', {
      school_id: schoolId,
      salary_code: {
        name: name,
        loenart: loenart,
        tillaegsnummer: tillaegsnummer
      }
    }, success, failure)
  }

  readTaskCategories (schoolId, schoolYearId, success, failure) {
    this.state.websocket.trigger('api.task_categories.index', {
      school_id: schoolId,
      school_year_id: schoolYearId
    }, success, failure)
  }

  createTaskCategory (schoolId, schoolYearId, name, rank, subjectTypes, success, failure) {
    this.state.websocket.trigger('api.task_categories.create', {
      school_id: schoolId,
      school_year_id: schoolYearId,
      name: name,
      rank: rank,
      subject_types: subjectTypes
    }, success, failure)
  }

  updateTaskCategory (schoolId, schoolYearId, id, name, rank, subjectTypes, success, failure) {
    this.state.websocket.trigger('api.task_categories.update', {
      school_id: schoolId,
      school_year_id: schoolYearId,
      id: id,
      name: name,
      rank: rank,
      subject_types: subjectTypes
    }, success, failure)
  }

  deleteTaskCategory (schoolId, schoolYearId, id, success, failure) {
    this.state.websocket.trigger('api.task_categories.destroy', {
      school_id: schoolId,
      school_year_id: schoolYearId,
      id: id
    }, success, failure)
  }

  readSubjectCalendars (schoolId, schoolYearId, success, failure) {
    this.state.websocket.trigger('api.subject_calendars.index', {
      school_id: schoolId,
      school_year_id: schoolYearId
    }, success, failure)
  }

  // dispatcher.trigger('api.subject_calendars.bulk_update', {school_id: 3, school_year_id: 5, updates: [{id: 1, selected_task_category_id: 1}]}, function(data) {console.log(data)});
  bulkUpdateSubjectCalendars (schoolId, schoolYearId, updates, success, failure) {
    this.state.websocket.trigger('api.subject_calendars.bulk_update', {
      school_id: schoolId,
      school_year_id: schoolYearId,
      updates: updates
    }, success, failure)
  }

  // dispatcher.trigger('api.subject_calendars.bulk_update_supplement_type', {school_id: 3, school_year_id: 5, updates: [{id: 1, salary_supplement_type_id: 1}]}, function(data) {console.log(data)});
  bulkUpdateSubjectCalendarsSupplementType (schoolId, schoolYearId, updates, success, failure) {
    this.state.websocket.trigger('api.subject_calendars.bulk_update_supplement_type', {
      school_id: schoolId,
      school_year_id: schoolYearId,
      updates: updates
    }, success, failure)
  }

  // requires: can_do_most_stuff
  // dispatcher.trigger('api.imports.index', {school_id: 3}, function(data) {console.log(data)});
  listImports (schoolId, success, failure) {
    this.state.websocket.trigger('api.imports.index', {
      school_id: schoolId
    }, success, failure)
  }

  // requires: can_do_most_stuff
  // dispatcher.trigger('api.imports.create', {school_id: 3, date: '2021-04-11', schedule_uuid: '0cd11857-0542-4a26-a65b-d8cdc35ae09a', school_year_id: 3400}, function(data) {console.log(data)});
  enqueueImport (schoolId, scheduleUuid, date, schoolYearId, success, failure) {
    this.state.websocket.trigger('api.imports.create', {
      school_id: schoolId,
      schedule_uuid: scheduleUuid,
      date: date,
      school_year_id: schoolYearId
    }, success, failure)
  }

  // requires none
  // dispatcher.trigger('api.subjects.subjects_for_calendar_type',{country: 'DK', calendar_type: 'user'}, function(data) {console.log(data)})
  subjectsForCalendarType (calendarType, country, success, failure) {
    this.state.websocket.trigger('api.subjects.subjects_for_calendar_type', {
      calendar_type: calendarType,
      country: country
    }, success, failure)
  }

  // dispatcher.trigger('api.subject_actuals.read',{school_id: 3, school_year_id: 3438, user_id: 12, from_date: '2020-08-01', to_date: '2021-07-29'}, function(data) {console.log(data)})
  subjectActuals (schoolId, schoolYearId, userId, fromDate, toDate, success, failure) {
    this.state.websocket.trigger('api.subject_actuals.read', {
      school_id: schoolId,
      school_year_id: schoolYearId,
      user_id: userId,
      from_date: fromDate,
      to_date: toDate
    }, success, failure)
  }

  // dispatcher.trigger('api.users.tasks',{user_id: 12, from_date: '2020-08-01', to_date: '2021-07-29'}, function(data) {console.log(data)})
  userTasks (userId, fromDate, toDate, success, failure) {
    this.state.websocket.trigger('api.users.tasks', {
      user_id: userId,
      from_date: fromDate,
      to_date: toDate
    }, success, failure)
  }

  // dispatcher.trigger('api.calendars.actual_hours_per_week_per_master_type',{calendar_id: 105384, from_date: '2020-08-01', to_date: '2021-07-29'}, function(data){console.log(data)})
  // plus forberedelse og arbejdstid, andre?
  calendarActualHoursPerWeek (calendarId, fromDate, toDate, success, failure) {
    this.state.websocket.trigger('api.calendars.actual_hours_per_week_per_master_type', {
      calendar_id: calendarId,
      from_date: fromDate,
      to_date: toDate
    }, success, failure)
  }

  // dispatcher.trigger('api.calendar_relations.create', {school_id: 3, calendar_id: 182685, other_calendar_id: 154389, relation: 'student_of'}, function(data){console.log(data)})
  createCalendarRelation (schoolId, calendarId, otherCalendarId, relation, success, failure) {
    this.state.websocket.trigger('api.calendar_relations.create', {
      school_id: schoolId,
      calendar_id: calendarId,
      other_calendar_id: otherCalendarId,
      relation: relation
    }, success, failure)
  }

  // dispatcher.trigger('api.calendar_relations.destroy', {school_id: 3, id: 1}, function(data){console.log(data)})
  deleteCalendarRelation (schoolId, id, success, failure) {
    this.state.websocket.trigger('api.calendar_relations.destroy', {
      school_id: schoolId,
      id: id
    }, success, failure)
  }

  // dispatcher.trigger('api.calendar_relations.index', {school_id: 3}, function(data){console.log(data)})
  indexCalendarRelations (schoolId, success, failure) {
    this.state.websocket.trigger('api.calendar_relations.index', {
      school_id: schoolId
    }, success, failure)
  }

  // requires: can_manage_users
  // dispatcher.trigger('api.employment_types.read', {school_id: 3}, function(data) {console.log(data)}, failure)
  employmentTypesForSchool (schoolId, success, failure) {
    this.state.websocket.trigger('api.employment_types.read', {
      school_id: schoolId
    }, success, failure)
  }

  // returns: [{"id":3,"school_id":111,"title":"Lærervikar","manual_salary":true,"salary_codes":[]}]

  // requires: can_manage_users
  // dispatcher.trigger('api.employment_types.create', {school_id: 3, employment_type: { title: 'Pædagogvikar, klub' } }, function(data) {console.log(data)}, failure)
  createEmploymentType (schoolId, title, manualSalary, success, failure) {
    this.state.websocket.trigger('api.employment_types.create', {
      school_id: schoolId,
      employment_type: {
        title: title,
        manual_salary: manualSalary
      }
    }, success, failure)
  }

  // returns: {"id":6,"school_id":114,"title":"Teacher","manual_salary":true,"salary_codes":[]}

  updateEmploymentType (schoolId, id, title, manualSalary, success, failure) {
    this.state.websocket.trigger('api.employment_types.update', {
      id: id,
      school_id: schoolId,
      employment_type: {
        title: title,
        manual_salary: manualSalary
      }
    }, success, failure)
  }

  // returns: {"id":4,"school_id":112,"title":"Pædagogvikar","manual_salary":true,"salary_codes":[]}

  // dispatcher.trigger('api.employment_types.delete', {school_id: 36305, id: 1}, function(data) {console.log(data)}, failure)
  deleteEmploymentType (schoolId, id, success, failure) {
    this.state.websocket.trigger('api.employment_types.delete', {
      id: id,
      school_id: schoolId
    }, success, failure)
  }

  // returns: {"id":5,"school_id":113,"title":"Lærervikar","manual_salary":true,"salary_codes":[]}

  // dispatcher.trigger('api.subjects.sidebar',{calendar_id: 191682, date: '2021-12-09'}, function(data) {console.log(data)})
  sidebar (calendarId, date, success, failure) {
    this.state.websocket.trigger('api.subjects.sidebar', {
      calendar_id: calendarId,
      date: date
    }, success, failure)
  }

  listSchools (success, failure) {
    this.state.websocket.trigger('api.schools.index', {}, success, failure)
  }

  // dispatcher.trigger('api.schools.show',{id: 3}, function(data) {console.log(data)})
  showSchool (schoolId, success, failure) {
    this.state.websocket.trigger('api.schools.show', {
      id: schoolId
    }, success, failure)
  }

  absenceForDate (schoolId, date, success, failure) {
    this.state.websocket.trigger('api.schools.absence_for_date', {
      id: schoolId,
      date: date
    }, success, failure)
  }

  // let updates = {subject_default_duration: 30}
  // dispatcher.trigger('api.schools.update',{id: 3, school: {custom_data: {settings: 'test' }}}, function(data) {console.log(data)})
  // possible updates are: name, time_zone, first_day_of_week_num, subject_default_duration, anonymous_access, open_substitutions, custom_data, substitute_rules
  // requires: can_manage_school
  updateSchool (schoolId, updates, success, failure) {
    this.state.websocket.trigger('api.schools.update', {
      id: schoolId,
      school: updates
    }, success, failure)
  }

  // dispatcher.trigger('api.calendars.create_norm_subjects',{school_id: 3, [calendar_id: 200179, step: 5]}, function(data) {console.log(data)})
  calendarCreateNormSubjects (schoolId, calendarStepList, success, failure) {
    this.state.websocket.trigger('api.calendars.create_norm_subjects', {
      school_id: schoolId,
      calendar_steps: calendarStepList
    }, success, failure)
  }

  // dispatcher.trigger('api.calendars.availability', { calendar_id: 5, event_id: 321, start: '2022-01-31 00:00', end: '2022-02-05 00:00' }, function(data) {console.log(data)}, failure);
  eventAvailability (calendarId, eventId, start, end, success, failure) {
    this.state.websocket.trigger('api.calendars.availability', {
      calendar_id: calendarId,
      event_id: eventId,
      start: start,
      end: end
    }, success, failure)
  }

  // dispatcher.trigger('api.calendars.availability', { calendar_id: 5, subject_id: 123, start: '2022-01-31 00:00', end: '2022-02-05 00:00' }, function(data) {console.log(data)}, failure);
  subjectAvailability (calendarId, subjectId, start, end, success, failure) {
    this.state.websocket.trigger('api.calendars.availability', {
      calendar_id: calendarId,
      subject_id: subjectId,
      start: start,
      end: end
    }, success, failure)
  }

  // dispatcher.trigger('api.stil_reports.show', {school_id: 3}, function(data) {console.log(data)}, failure)
  showStilReport (schoolId, success, failure) {
    this.state.websocket.trigger('api.stil_reports.show', {
      school_id: schoolId
    }, success, failure)
  }

  // dispatcher.trigger('api.stil_reports.update', {school_id: 3, data: {}}, function(data) {console.log(data)}, failure)
  updateStilReport (schoolId, report, success, failure) {
    this.state.websocket.trigger('api.stil_reports.update', {
      school_id: schoolId,
      report: report
    }, success, failure)
  }

  // dispatcher.trigger('api.stil_reports.submit', {school_id: 3}, function(data) {console.log(data)}, failure)
  submitStilReport (schoolId, success, failure) {
    this.state.websocket.trigger('api.stil_reports.submit', {
      school_id: schoolId
    }, success, failure)
  }

  // dispatcher.trigger('api.stil_competency.show', {school_id: 3}, function(data) {console.log(data)}, failure)
  showStilCompetencyReport (schoolId, success, failure) {
    this.state.websocket.trigger('api.stil_competency.show', {
      school_id: schoolId
    }, success, failure)
  }

  // dispatcher.trigger('api.stil_competency.update', {school_id: 3, data: {}}, function(data) {console.log(data)}, failure)
  updateStilCompetencyReport (schoolId, report, success, failure) {
    this.state.websocket.trigger('api.stil_competency.update', {
      school_id: schoolId,
      report: report
    }, success, failure)
  }

  // dispatcher.trigger('api.stil_competency.submit', {school_id: 3}, function(data) {console.log(data)}, failure)
  submitStilCompetencyReport (schoolId, success, failure) {
    this.state.websocket.trigger('api.stil_competency.submit', {
      school_id: schoolId
    }, success, failure)
  }

  // dispatcher.trigger('api.users.competencies.index', {school_id: 3, user_id: 12}, function(data){console.log(data)})
  listUserCompetencies (schoolId, userId, success, failure) {
    this.state.websocket.trigger('api.users.competencies.index', {
      school_id: schoolId,
      user_id: userId
    }, success, failure)
  }

  // dispatcher.trigger('api.users.competencies.update', {school_id: 3, user_id: 12, competencies: [{subject_code: 110, level: 'L'}] }, function(data){console.log(data)})
  updateUserCompetencies (schoolId, userId, competencies, success, failure) {
    this.state.websocket.trigger('api.users.competencies.update', {
      school_id: schoolId,
      user_id: userId,
      competencies: competencies
    }, success, failure)
  }

  // dispatcher.trigger('api.events.delete_this_and_following', {school_id: 7272, event_id: 56231750}, function (data) {console.log(data)})
  eventsDeleteThisAndFollowing (schoolId, eventId, success, failure) {
    this.state.websocket.trigger(
      'api.events.delete_this_and_following', {
        school_id: schoolId,
        event_id: eventId
      }, success, failure
    )
  }

  // dispatcher.trigger('api.events.swap', {school_id: 7272, from: 56231836, to: 56231839}, function (data) {console.log(data)})
  eventSwap (schoolId, fromEventId, toEventId, success, failure) {
    this.state.websocket.trigger(
      'api.events.swap', {
        school_id: schoolId,
        from: fromEventId,
        to: toEventId
      }, success, failure
    )
  }

  // dispatcher.trigger('api.events.replace', {school_id: 7272, event: 56231836, subject: 56231839}, function (data) {console.log(data)})
  eventReplace (schoolId, eventId, subjectId, success, failure) {
    this.state.websocket.trigger(
      'api.events.replace', {
        school_id: schoolId,
        event: eventId,
        subject: subjectId
      }, success, failure
    )
  }

  // dispatcher.trigger('api.events.replace_calendar', {school_id: 7272, event_id: 59479579, calendar_id_to_replace: 85674, calendar_id_to_replace_with: 222186}, function (data) {console.log(data)})
  eventReplaceCalendar (schoolId, eventId, calendarIdToReplace, calendarIdToReplaceWith, success, failure) {
    this.state.websocket.trigger(
      'api.events.replace_calendar', {
        school_id: schoolId,
        event_id: eventId,
        calendar_id_to_replace: calendarIdToReplace,
        calendar_id_to_replace_with: calendarIdToReplaceWith
      }, success, failure
    )
  }

  // dispatcher.trigger('api.events.add_calendar', {school_id: 7272, event_id: 59479571, calendar_id_to_add: 222186}, function (data) {console.log(data)})
  eventAddCalendar (schoolId, eventId, calendarIdToAdd, success, failure) {
    this.state.websocket.trigger(
      'api.events.add_calendar', {
        school_id: schoolId,
        event_id: eventId,
        calendar_id_to_add: calendarIdToAdd
      }, success, failure
    )
  }

  // dispatcher.trigger('api.events.remove_calendar', {school_id: 7272, event_id: 59479571, calendar_id_to_remove: 222186}, function (data) {console.log(data)})
  eventRemoveCalendar (schoolId, eventId, calendarIdToRemove, success, failure) {
    this.state.websocket.trigger(
      'api.events.remove_calendar', {
        school_id: schoolId,
        event_id: eventId,
        calendar_id_to_remove: calendarIdToRemove
      }, success, failure
    )
  }

  // dispatcher.trigger('api.events.list_swapable_events', {school_id: 7272, event_id: 56231786}, function (data) {console.log(data)})
  eventListSwapable (schoolId, eventId, success, failure) {
    this.state.websocket.trigger(
      'api.events.list_swapable_events', {
        school_id: schoolId,
        event_id: eventId
      }, success, failure
    )
  }

  // dispatcher.trigger('api.events.list_replaceable_events', {school_id: 7272, event_id: 56231786}, function (data) {console.log(data)})
  eventListReplaceable (schoolId, eventId, success, failure) {
    this.state.websocket.trigger(
      'api.events.list_replaceable_events', {
        school_id: schoolId,
        event_id: eventId
      }, success, failure
    )
  }

  // dispatcher.trigger('api.calendars.hours_count', {calendar_id: 218330, start: '2022-08-01', end: '2023-07-31'}, function(data) {console.log(data)})
  hoursCountForCalendar (schoolId, calendarId, start, end, success, failure) {
    this.state.websocket.trigger(
      'api.calendars.hours_count', {
        school_id: schoolId,
        calendar_id: calendarId,
        start: start,
        end: end
      }, success, failure
    )
  }

  // dispatcher.trigger('api.schools.task_overviews.create', {school_id: 7272, school_year_id: 11774, user_id: 12, title: 'Udkast 1'}, function(data){console.log(data)})
  saveTaskOverview (schoolId, schoolYearId, userId, title, success, failure) {
    this.state.websocket.trigger(
      'api.schools.task_overviews.create', {
        school_id: schoolId,
        school_year_id: schoolYearId,
        user_id: userId,
        title: title
      }, success, failure
    )
  }

  // dispatcher.trigger('api.schools.task_overviews.bulk_create', {school_id: 7272, school_year_id: 11774, user_ids: [12, 13, 15]}, function(data){console.log(data)})
  bulkCreateTaskOverview (schoolId, schoolYearId, userIds, title, success, failure) {
    this.state.websocket.trigger(
      'api.schools.task_overviews.bulk_create', {
        school_id: schoolId,
        school_year_id: schoolYearId,
        user_ids: userIds,
        title: title
      }, success, failure
    )
  }

  // dispatcher.trigger('api.schools.task_overviews.index', {school_id: 7272, school_year_id: 11774, user_id: 12}, function(data){console.log(data)})
  readTaskOverviews (schoolId, schoolYearId, userId, success, failure) {
    this.state.websocket.trigger(
      'api.schools.task_overviews.index', {
        school_id: schoolId,
        school_year_id: schoolYearId,
        user_id: userId
      }, success, failure
    )
  }

  deleteTaskOverview (schoolId, schoolYearId, userId, versionId, success, failure) {
    this.state.websocket.trigger(
      'api.schools.task_overviews.destroy', {
        school_id: schoolId,
        school_year_id: schoolYearId,
        user_id: userId,
        id: versionId
      }, success, failure
    )
  }

  readAllTaskOverview (schoolId, schoolYearId, success, failure) {
    this.state.websocket.trigger(
      'api.schools.task_overviews.latest_per_user', {
        school_id: schoolId,
        school_year_id: schoolYearId
      }, success, failure
    )
  }

  listSubjectRequests (schoolId, schoolYearId, success, failure) {
    this.state.websocket.trigger(
      'api.subject_requests.index', {
        school_id: schoolId,
        school_year_id: schoolYearId
      }, success, failure
    )
  }

  createSubjectRequest (schoolId, schoolYearId, subjectId, success, failure) {
    this.state.websocket.trigger(
      'api.subject_requests.create', {
        school_id: schoolId,
        school_year_id: schoolYearId,
        subject_id: subjectId
      }, success, failure
    )
  }

  deleteSubjectRequest (schoolId, schoolYearId, id, success, failure) {
    this.state.websocket.trigger(
      'api.subject_requests.destroy', {
        school_id: schoolId,
        school_year_id: schoolYearId,
        id: id
      }, success, failure
    )
  }

  // dispatcher.trigger('api.subject_reductions.index', {school_id: 7272, school_year_id: 18289}, function(data) {console.log(data)}, failure)
  listSubjectReductions (schoolId, schoolYearId, success, failure) {
    this.state.websocket.trigger(
      'api.subject_reductions.index', {
        school_id: schoolId,
        school_year_id: schoolYearId
      }, success, failure
    )
  }

  // dispatcher.trigger('api.subject_reductions.refresh', {school_id: 7272, school_year_id: 18289}, function(data) {console.log(data)}, failure)
  refreshSubjectReductions (schoolId, schoolYearId, success, failure) {
    this.state.websocket.trigger(
      'api.subject_reductions.refresh', {
        school_id: schoolId,
        school_year_id: schoolYearId
      }, success, failure
    )
  }

  // dispatcher.trigger('api.salary_supplement_types.index', {school_id: 7272}, function(data) {console.log(data)}, failure)
  listSalarySupplementTypes (schoolId, success, failure) {
    this.state.websocket.trigger(
      'api.salary_supplement_types.index', {
        school_id: schoolId
      }, success, failure
    )
  }

  // dispatcher.trigger('api.salary_supplement_types.create', {school_id: 7272, title: 'Undervisningstillæg', code: '111122', account: 'JEFB3'}, function(data) {console.log(data)}, failure)
  createSalarySupplementType (schoolId, title, code, account, success, failure) {
    this.state.websocket.trigger(
      'api.salary_supplement_types.create', {
        school_id: schoolId,
        title: title,
        code: code,
        account: account
      }, success, failure
    )
  }

  // dispatcher.trigger('api.salary_supplement_types.update', {school_id: 7272, id: 1, end_date: '2026-07-31'}, function(data) {console.log(data)}, failure)
  updateSalarySupplementType (schoolId, id, endDate, success, failure) {
    this.state.websocket.trigger(
      'api.salary_supplement_types.update', {
        school_id: schoolId,
        id: id,
        end_date: endDate
      }, success, failure
    )
  }

  // dispatcher.trigger('api.salary_supplements.index', {school_id: 62084, school_year_id: 20651}, function(data) {console.log(data)}, failure)
  listSalarySupplements (schoolId, schoolYearId, success, failure) {
    this.state.websocket.trigger(
      'api.salary_supplements.index', {
        school_id: schoolId,
        school_year_id: schoolYearId
      }, success, failure
    )
  }

  // dispatcher.trigger('api.salary_supplements.create', {school_id: 7272, school_year_id: 1, user_id: 1, employment_id: 1, year_norm_hours: 1924.0, start_date: '2025-08-01', end_date: '2026-07-31', code: '111122', account: 'JEFB2', units: 300, installments: 12, units_per_installment: 25 }, function(data) {console.log(data)}, failure)
  createSalarySupplement (schoolId, schoolYearId, userId, employmentId, yearNormHours, startDate, endDate, code, account, units, installments, unitsPerInstallment, success, failure) {
    this.state.websocket.trigger(
      'api.salary_supplements.create', {
        school_id: schoolId,
        school_year_id: schoolYearId,
        user_id: userId,
        employment_id: employmentId,
        year_norm_hours: yearNormHours,
        start_date: startDate,
        end_date: endDate,
        code: code,
        account: account,
        units: units,
        installments: installments,
        units_per_installment: unitsPerInstallment
      }, success, failure
    )
  }

  updateSalarySupplement (schoolId, schoolYearId, id, userId, employmentId, yearNormHours, startDate, endDate, code, account, units, installments, unitsPerInstallment, success, failure) {
    this.state.websocket.trigger(
      'api.salary_supplements.update', {
        school_id: schoolId,
        school_year_id: schoolYearId,
        id: id,
        user_id: userId,
        employment_id: employmentId,
        year_norm_hours: yearNormHours,
        code: code,
        account: account,
        units: units,
        installments: installments,
        units_per_installment: unitsPerInstallment
      }, success, failure
    )
  }

  deleteSalarySupplement (schoolId, schoolYearId, id, success, failure) {
    this.state.websocket.trigger(
      'api.salary_supplements.delete', {
        school_id: schoolId,
        school_year_id: schoolYearId,
        id: id
      }, success, failure
    )
  }

  // dispatcher.trigger('api.salary_supplements.generate', {school_id: 62084, school_year_id: 20651, supplement_type: 'lønbrøk'}, function(data) {console.log(data)}, failure)
  generateSalarySupplements (schoolId, schoolYearId, supplementType, success, failure) {
    this.state.websocket.trigger(
      'api.salary_supplements.generate', {
        school_id: schoolId,
        school_year_id: schoolYearId,
        supplement_type: supplementType
      }, success, failure
    )
  }

  // dispatcher.trigger('api.requests.list', {school_id: 1}, function(data) {console.log(data)}, failure)
  listRequests (schoolId, success, failure) {
    this.state.websocket.trigger(
      'api.requests.list', {
        school_id: schoolId
      }, success, failure
    )
  }

  // dispatcher.trigger('api.requests.create', {school_id: 1, subject_id: 1, start_time: '2025-07-01 08:00', end_time: '2025-07-01 16:00', request_note: 'Plz' }, function(data) {console.log(data)}, failure)
  createRequest (schoolId, subjectId, startTime, endTime, requestNote, success, failure) {
    this.state.websocket.trigger(
      'api.requests.create', {
        school_id: schoolId,
        subject_id: subjectId,
        start_time: startTime,
        end_time: endTime,
        request_note: requestNote
      }, success, failure
    )
  }

  // dispatcher.trigger('api.requests.update', {school_id: 1, id: 1, ...subjectId, startTime, endTime, requestNote... }, function(data) {console.log(data)}, failure)
  updateRequest (schoolId, id, subjectId, startTime, endTime, requestNote, success, failure) {
    this.state.websocket.trigger(
      'api.requests.update', {
        school_id: schoolId,
        id: id,
        subject_id: subjectId,
        start_time: startTime,
        end_time: endTime,
        request_note: requestNote
      }, success, failure
    )
  }

  // dispatcher.trigger('api.requests.approve', {school_id: 1, id: 1, response_note: 'Ok' }, function(data) {console.log(data)}, failure)
  approveRequest (schoolId, id, responseNote, success, failure) {
    this.state.websocket.trigger(
      'api.requests.approve', {
        school_id: schoolId,
        id: id,
        response_note: responseNote
      }, success, failure
    )
  }

  // dispatcher.trigger('api.requests.reject', {school_id: 1, id: 1, response_note: 'Nah' }, function(data) {console.log(data)}, failure)
  rejectRequest (schoolId, id, responseNote, success, failure) {
    this.state.websocket.trigger(
      'api.requests.reject', {
        school_id: schoolId,
        id: id,
        response_note: responseNote
      }, success, failure
    )
  }

  // dispatcher.trigger('api.requests.delete', {school_id: 1, id: 1}, function(data) {console.log(data)}, failure)
  deleteRequest (schoolId, id, success, failure) {
    this.state.websocket.trigger(
      'api.requests.delete', {
        school_id: schoolId,
        id: id
      }, success, failure
    )
  }

  trackEvent (schoolId, event, success, failure) {
    this.state.websocket.trigger(
      'api.track_events.track', {
        school_id: schoolId,
        event: event
      }, success, failure
    )
  }

  getRecentUsers (id, limit, success, failure) {
    this.state.websocket.trigger('api.schools.recent_users', {school: id, limit: limit}, success, failure)
  }

  // requires: can_manage_users
  createEmploymentTemplate (schoolId, title, manualSalary, salaryCodeId, omkostningssted, success, failure) {
    this.state.websocket.trigger('api.employment_templates.create', {
      school_id: schoolId,
      employment_template: {
        title: title,
        manual_salary: manualSalary,
        salary_code_id: salaryCodeId,
        omkostningssted: omkostningssted
      }
    }, success, failure)
  }

  // requires: can_manage_users
  employmentTemplatesForSchool (schoolId, success, failure) {
    this.state.websocket.trigger('api.employment_templates.read', {
      school_id: schoolId
    }, success, failure)
  }

  updateEmploymentTemplate (schoolId, employmentTemplateId, title, manualSalary, salaryCodeId, omkostningssted, success, failure) {
    this.state.websocket.trigger('api.employment_templates.update', {
      school_id: schoolId,
      id: employmentTemplateId,
      employment_template: {
        title: title,
        manual_salary: manualSalary,
        salary_code_id: salaryCodeId,
        omkostningssted: omkostningssted
      }
    }, success, failure)
  }

  // requires: can_manage_users
  deleteEmploymentTemplate (schoolId, employmentTemplateId, success, failure) {
    this.state.websocket.trigger('api.employment_templates.delete', {
      school_id: schoolId,
      id: employmentTemplateId
    }, success, failure)
  }

  createSalaryCostCenter (schoolId, name, code, success, failure) {
    this.state.websocket.trigger('api.salary_cost_centers.create', {
      school_id: schoolId,
      name: name,
      code: code
    }, success, failure)
  }

  listSalaryCostCenter (schoolId, success, failure) {
    this.state.websocket.trigger('api.salary_cost_centers.index', {
      school_id: schoolId
    }, success, failure)
  }

}

const instance = new Docendo()
instance.state = {} // docendo object is frozen so this is for mutable state
instance.state.reconnectTimeout = Math.floor(1000 + Math.random() * 2000)
instance.state.retries = 1
instance.state.observersConnected = []
instance.state.observersDisconnected = []
instance.open()
Object.freeze(instance)
export default instance



// WEBPACK FOOTER //
// ./src/docendo.js